import { FC, useEffect, useState } from 'react';
import './invoiceTable.scss';
import { Internationalization } from '@syncfusion/ej2-base';
import NumberFormat from 'react-number-format';
import { RootState } from '../../../redux/store';
import { useSelector } from 'react-redux';

type CompanyInvoiceData = {
    companyId: number;
    companyName: string;
    pallets: number;
    bins: number;
    boxes: number;
    items: number;
    cost: number;
    price: number;
};

interface IInvoiceTable {
    filteredCompanyDetails?: any[];
    invoiceTableData: CompanyInvoiceData[];
}

const InvoiceTable: FC<IInvoiceTable> = ({
    invoiceTableData,
    filteredCompanyDetails,
}) => {
    const [selectedCompanyId, setSelectedCompanyId] = useState<number | null>(
        null
    );
       const arInvoiceSavedata = useSelector(
            (store: RootState) => store.invoiceReducer.arInvoiceSaveData
        );
    let intl = new Internationalization();

    useEffect(() => {
        if (invoiceTableData?.length > 0) {
            setSelectedCompanyId(invoiceTableData[0].companyId);
        }
    }, [invoiceTableData]);

    const selectedCompany = invoiceTableData?.find(
        (c) => c.companyId === selectedCompanyId
    );

    const handleCompanyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedCompanyId(Number(e.target.value));
    };
    return (
        <div className="invoice-table">
            <div className="invoice-table-header">
                <span style={{ width: 200 }}>Company Name</span>
                <span>PALLETS</span>
                <span>BINS</span>
                <span>BOXES</span>
                <span>ITEMS</span>
                <span>GROSS COST</span>
                <span>NET PRICE</span>
            </div>
            <div className="invoice-table-content">
                <span style={{ width: 200 }}>
                    <select
                        value={selectedCompanyId ?? ''}
                        onChange={handleCompanyChange}
                        disabled={invoiceTableData?.length === 0}
                        className="form-control"
                        style={{ width: 150 }}
                    >
                        {invoiceTableData?.map((item) => (
                            <option key={item.companyId} value={item.companyId}>
                                {item.companyName}
                            </option>
                        ))}
                    </select>
                </span>
                <span>{selectedCompany?.pallets ?? 0}</span>
                <span>{selectedCompany?.bins ?? 0}</span>
                <span>{selectedCompany?.boxes ?? 0}</span>
                <span>
                    <NumberFormat
                        displayType="text"
                        thousandSeparator
                        value={selectedCompany?.items ?? 0}
                    />
                </span>
                <span>
                    <NumberFormat
                        displayType="text"
                        thousandSeparator
                        value={(selectedCompany?.cost ?? 0).toFixed(2)}
                    />
                </span>

                <span>
                    <NumberFormat
                        displayType="text"
                        thousandSeparator
                        value={(selectedCompany?.price ?? 0).toFixed(2)}
                    />
                </span>
                {/* <span>{`$${nFormatter(+cost)}`}</span> */}
                {/* <span>{`$${nFormatter(+price)}`}</span> */}
                {/* <span>${parseFloat(cost).toFixed(2)}</span> */}
                {/* <span>${parseFloat(price).toFixed(2)}</span> */}
            </div>
        </div>
    );
};

export default InvoiceTable;
